import { render, staticRenderFns } from "./WxSelectGoods.vue?vue&type=template&id=97b481aa&scoped=true&"
import script from "./WxSelectGoods.vue?vue&type=script&lang=js&"
export * from "./WxSelectGoods.vue?vue&type=script&lang=js&"
import style0 from "./WxSelectGoods.vue?vue&type=style&index=0&id=97b481aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b481aa",
  null
  
)

export default component.exports